
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/accessibility",
      function () {
        return require("private-next-pages/fr/accessibility.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/accessibility"])
      });
    }
  